import * as React from 'react'
import {
  DashboardMenuItem,
  Menu,
  MenuItemLink,
  usePermissions,
  useGetIdentity,
} from 'react-admin'
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer'
import FeaturedPlayListIcon from '@material-ui/icons/FeaturedPlayList'
import UserIcon from '@material-ui/icons/People'
import RssFeedIcon from '@material-ui/icons/RssFeed'
import EmojiSymbolsIcon from '@material-ui/icons/EmojiSymbols'
import WsCampaignIcon from '@material-ui/icons/Launch'
import DeliveryIcon from '@material-ui/icons/BarChart'
import { useTranslate } from 'ra-core'
import { hasAccess } from 'ra-auth-acl'

export const MenuApp = props => {
  const translate = useTranslate()
  const { isLoading, permissions } = usePermissions()
  const { identity } = useGetIdentity()
  if (isLoading) return null
  if (!identity) return null
  return (
    <Menu {...props}>
      <DashboardMenuItem />
      {hasAccess(permissions, 'user.enabled') && (
        <MenuItemLink
          to={{
            pathname: '/user',
            search: getFilterSearch(identity, true),
          }}
          primaryText={translate('surveys.resources.users')}
          leftIcon={<UserIcon />}
        />
      )}
      {hasAccess(permissions, 'campaigns.enabled') && (
        <MenuItemLink
          to={{
            pathname: '/campaigns',
            search: getFilterSearch(identity, true),
          }}
          primaryText={translate('surveys.resources.campaigns')}
          leftIcon={<RssFeedIcon />}
        />
      )}
      {hasAccess(permissions, 'questions.enabled') && (
        <MenuItemLink
          to={{
            pathname: '/questions',
            search: getFilterSearch(identity, true),
          }}
          primaryText={translate('surveys.resources.questions')}
          leftIcon={<QuestionAnswerIcon />}
        />
      )}
      {hasAccess(permissions, 'responses.enabled')}
      {hasAccess(permissions, 'thematics.enabled') && (
        <MenuItemLink
          to={{
            pathname: '/thematics',
            search: getFilterSearch(identity, true),
          }}
          primaryText={translate('surveys.resources.thematics')}
          leftIcon={<EmojiSymbolsIcon />}
        />
      )}
      {hasAccess(permissions, 'coregs.enabled') && (
        <MenuItemLink
          to={{
            pathname: '/coregs',
            search: getFilterSearch(identity, true),
          }}
          primaryText={translate('surveys.resources.coregs')}
          leftIcon={<FeaturedPlayListIcon />}
        />
      )}
      {hasAccess(permissions, 'wscampaigns.enabled') && (
        <MenuItemLink
          to={{
            pathname: '/wscampaigns',
            search: getFilterSearch(identity, false),
          }}
          primaryText={translate('surveys.resources.wscampaigns')}
          leftIcon={<WsCampaignIcon />}
        />
      )}
      {hasAccess(permissions, 'delivery.enabled') && (
        <MenuItemLink
          to={{
            pathname: '/delivery',
            search: getFilterSearch(identity, false),
          }}
          primaryText={translate('surveys.resources.delivery')}
          leftIcon={<DeliveryIcon />}
        />
      )}
    </Menu>
  )
}

const getFilterSearch = (identity, applyFilter = true) => {
  if (!applyFilter || identity.role === 'admin') {
    return ''
  }
  return `filter=${JSON.stringify({ country: identity.country })}`
}
